import React, { FC } from 'react';
import styled from 'styled-components';
import theme from '^/theme';

interface ToggleProps {
  isOn: boolean;
  disabled?: boolean;
  onChange?(newState: boolean): void;
  className?: string;
}

interface StyleProps {
  isOn: boolean;
  disabled?: boolean;
}

const Container = styled.div({
  display: 'inline-flex',
  alignItems: 'center',
  gap: '8px',
});

const Track = styled.div<StyleProps>(({ isOn, disabled }) => ({
  position: 'relative',
  display: 'flex',
  width: '40px',
  height: '20px',
  padding: '4px',
  justifyContent: isOn ? 'flex-end' : 'flex-start',
  alignItems: 'center',
  gap: '4px',
  backgroundColor: isOn
    ? disabled
      ? theme.colorTokens.disabledGray
      : theme.colorTokens.focusSkyblue
    : theme.colors.neutralGray[100],
  borderRadius: '100px',
  cursor: disabled ? 'not-allowed' : 'pointer',
  transition: 'all 0.2s ease-in-out',
}));

const Circle = styled.div<StyleProps>(({ disabled }) => ({
  width: '18px',
  height: '18px',
  flexShrink: 0,
  backgroundColor: disabled ? theme.colorTokens.disabledGray : theme.colors.white[100],
  borderRadius: '50%',
  boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.1)',
  transition: 'transform 0.2s ease-in-out',
}));

export const Toggle: FC<ToggleProps> = ({ isOn, disabled = false, onChange, className }) => {
  const handleClick = () => {
    if (!disabled && onChange) {
      onChange(!isOn);
    }
  };

  return (
    <Container className={className}>
      <Track
        isOn={isOn}
        disabled={disabled}
        onClick={handleClick}
        role="switch"
        aria-checked={isOn}
      >
        <Circle disabled={disabled} isOn={isOn} />
      </Track>
    </Container>
  );
};

export default Toggle;
